<template>
  <div class="agree"><p
    style="margin-top:0pt; margin-bottom:8pt; text-align:center; line-height:116%; widows:0; orphans:0; font-size:11pt">
    <span style="font-family:'等线'">默往</span><span style="font-family:'等线'">币</span><span
    style="font-family:'等线'">充</span><span style="font-family:'等线'">值</span><span
    style="font-family:'等线'">协议</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">更新时间：2025年</span><span style="font-family:'等线'">11</span><span
      style="font-family:'等线'">月</span><span style="font-family:'等线'">7</span><span
      style="font-family:'等线'">日</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">欢迎您使用</span><span style="font-family:'等线'">默往</span><span
      style="font-family:'等线'">币</span><span style="font-family:'等线'">服务！</span><span
      style="font-family:'等线'">默往</span><span style="font-family:'等线'">币</span><span
      style="font-family:'等线'">是</span><span style="font-family:'等线'">仅限</span><span
      style="font-family:'等线'">默往</span><span
      style="font-family:'等线'">App内使用的虚拟商品，不具有法定货币的性质和功能。</span><span
      style="font-family:'等线'">默往</span><span style="font-family:'等线'">币</span><span
      style="font-family:'等线'">充</span><span style="font-family:'等线'">值</span><span style="font-family:'等线'">协议（以下简称“本协议”）是</span><span
      style="font-family:'等线'">由</span><span style="font-family:'等线'">默往</span><span
      style="font-family:'等线'">App（以下简称“本平台”）的运营商</span><span style="font-family:'等线'">厦</span><span
      style="font-family:'等线'">门默往</span><span
      style="font-family:'等线'">科技有限公司（以下简称"本公司</span><span style="font-family:'等线'">”</span><span
      style="font-family:'等线'">）与您签订。为了让服务使用人（以下简称“您”或“用户”）更好的使用本平台的服务，请您在进行</span><span
      style="font-family:'等线'">默往</span><span style="font-family:'等线'">币充</span><span
      style="font-family:'等线'">值或使用</span><span style="font-family:'等线'">默往</span><span
      style="font-family:'等线'">币</span><span
      style="font-family:'等线'">兑换其他虚拟商品及增值服务前仔细阅读并充分理解本协议。</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">本平台不鼓励未成年人充</span><span style="font-family:'等线'">值</span><span
      style="font-family:'等线'">默往</span><span style="font-family:'等线'">币</span><span
      style="font-family:'等线'">，未成年用户请在家长或合法监护人的陪同下判断是否同意此协议。</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">您在充</span><span style="font-family:'等线'">值</span><span
      style="font-family:'等线'">默往</span><span style="font-family:'等线'">币后</span><span
      style="font-family:'等线'">不能将其逆向兑换为人民币或其他法定货币。</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">一、服务规则</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">1、</span><span style="font-family:'等线'">默往</span><span
      style="font-family:'等线'">币</span><span
      style="font-family:'等线'">是本平台提供的一种虚拟商品，可用于兑换包括但不限于</span><span
      style="font-family:'等线'">靓号、VIP会员、超级群、表情包</span><span
      style="font-family:'等线'">等虚拟商品及增值服务。</span><span style="font-family:'等线'">默往</span><span
      style="font-family:'等线'">币</span><span style="font-family:'等线'">仅可供您自己使用。</span><span
      style="font-family:'等线'">默往</span><span style="font-family:'等线'">币</span><span
      style="font-family:'等线'">一经充值成功，除法律法规明确规定外，在任何情况下不能兑换为法定货币。</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">2、用户可以</span><span style="font-family:'等线'">通过</span><span
      style="font-family:'等线'">微信支付</span><span style="font-family:'等线'">、支付宝支付、</span><span
      style="font-family:'等线'">iap</span><span style="font-family:'等线'">支付</span><span
      style="font-family:'等线'">途径进行</span><span style="font-family:'等线'">默往</span><span
      style="font-family:'等线'">币充</span><span
      style="font-family:'等线'">值。用户确认不会以非法方式或者使用非平台所指定的充</span><span
      style="font-family:'等线'">值途径充值</span><span style="font-family:'等线'">默往</span><span
      style="font-family:'等线'">币</span><span
      style="font-family:'等线'">，如果用户违规使用非本平台认可的充</span><span
      style="font-family:'等线'">值途径充值</span><span style="font-family:'等线'">默往</span><span
      style="font-family:'等线'">币</span><span style="font-family:'等线'">，则本平台不保证充</span><span
      style="font-family:'等线'">值顺利</span><span
      style="font-family:'等线'">或正确完成，若因此造成用户权益受损，本平台将不会</span><span
      style="font-family:'等线'">作出</span><span
      style="font-family:'等线'">任何补偿或赔偿，本平台同时保留随时终止用户</span><span
      style="font-family:'等线'">使用</span><span style="font-family:'等线'">默往</span><span
      style="font-family:'等线'">账号</span><span
      style="font-family:'等线'">及各项虚拟商品及增值服务的权利，并进行相应惩罚。</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">3、为保障用户财产安全，本平台有权对您的充</span><span
      style="font-family:'等线'">值行为</span><span
      style="font-family:'等线'">进行监测。经平台独立判断后认为用户存在</span><span
      style="font-family:'等线'">涉风险充</span><span
      style="font-family:'等线'">值行为（如不法分子通过诈骗、</span><span
      style="font-family:'等线'">盗刷信用卡</span><span style="font-family:'等线'">、洗钱、非法集资等非法来源资金用于充值），平台有权采取必要措施以防止风险扩大，包括但不限于限制交易额度和/或交易次数、冻结/扣除账号内的</span><span
      style="font-family:'等线'">默往</span><span style="font-family:'等线'">币</span><span
      style="font-family:'等线'">、限制部分功能、账号封禁，用户可以</span><span
      style="font-family:'等线'">通过</span><span style="font-family:'等线'">默往</span><span
      style="font-family:'等线'"> App内</span><span style="font-family:'等线'">-我的-客服入口</span><span
      style="font-family:'等线'">进行申诉。</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">4、用户确认，用户在进行充值前已经仔细确认过自己的账号并正确选择了符合自身意愿的操作选项，若因用户自身输入账号错误、操作不当或不了解充值计费方式等因素</span><span
      style="font-family:'等线'">造成充错账号</span><span
      style="font-family:'等线'">、错选充值种类等情形而损害自身权益的，本平台将不会</span><span
      style="font-family:'等线'">作出</span><span style="font-family:'等线'">任何补偿或赔偿。</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">5、用户确认，</span><span style="font-family:'等线'">默往</span><span
      style="font-family:'等线'">币只能</span><span
      style="font-family:'等线'">用于兑换本平台上的各类增值服务，任何情况下不得与第三方进行</span><span
      style="font-family:'等线'">默往</span><span style="font-family:'等线'">币</span><span
      style="font-family:'等线'">交易，亦不得在除本平台以外的第三方平台（如淘宝）上进行交易；如违反前述约定，造成用户或第三</span><span
      style="font-family:'等线'">方任何</span><span
      style="font-family:'等线'">损失，本平台不负任何责任，且如本平台有理由怀疑用户</span><span
      style="font-family:'等线'">的</span><span style="font-family:'等线'">默往</span><span
      style="font-family:'等线'">账号</span><span style="font-family:'等线'">或</span><span
      style="font-family:'等线'">默往</span><span style="font-family:'等线'">币使用</span><span
      style="font-family:'等线'">情况存在作弊或异常状况，本平台可以拒绝该用户使用</span><span
      style="font-family:'等线'">默往</span><span style="font-family:'等线'">币</span><span
      style="font-family:'等线'">功能，并按本协议约定采取封禁等措施。</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">6、本平台有权基于</span><span style="font-family:'等线'">默往</span><span
      style="font-family:'等线'">币使用</span><span
      style="font-family:'等线'">安全等方面的考虑不时设定或修改涉及</span><span
      style="font-family:'等线'">默往</span><span
      style="font-family:'等线'">币使用</span><span style="font-family:'等线'">的相关事项，包括但不限于</span><span
      style="font-family:'等线'">默往</span><span style="font-family:'等线'">币使用</span><span
      style="font-family:'等线'">限额、</span><span style="font-family:'等线'">默往</span><span
      style="font-family:'等线'">币使用</span><span
      style="font-family:'等线'">次数等。用户了解并确认本平台的前述设定或修改可能对用户的</span><span
      style="font-family:'等线'">默往</span><span style="font-family:'等线'">币使用</span><span
      style="font-family:'等线'">行为产生一定的不便，用户对此没有异议。</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">7、用户确认，除法律法规明确规定或本协议另有约定外，用户已兑换的任何虚拟商品及增值服务不能以任何理由退购（即退换</span><span
      style="font-family:'等线'">成</span><span style="font-family:'等线'">默往</span><span
      style="font-family:'等线'">币</span><span style="font-family:'等线'">或法定货币）或调换成其他服务。</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">8、因用户自身的原因导致本平台无法提供</span><span
      style="font-family:'等线'">默往</span><span style="font-family:'等线'">币</span><span
      style="font-family:'等线'">兑换服务或提供</span><span style="font-family:'等线'">默往</span><span
      style="font-family:'等线'">币</span><span style="font-family:'等线'">兑换服务时发生任何错误而产生的任何损失或责任，由用户自行负责，本平台不承担责任，包括但不限于：</span>
    </p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">(1)因用户</span><span style="font-family:'等线'">的</span><span
      style="font-family:'等线'">默往</span><span style="font-family:'等线'">账号</span><span
      style="font-family:'等线'">丢失、被封禁或冻结；</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">(2)用户将密码告知他人导致的财产损失；</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">(3)因用户绑定的第三方支付机构账户的原因导致的任何损失或责任；</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">(4)其他用户故意或者重大过失或者违反法律法规导致的财产损失。</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">9、用户在使用本平台提供的服务时，如出现违反国家法律法规、本协议约定或其他本平台对用户的管理规定的情形，本平台有权暂时或永久封禁用户的账号。账号被封禁后至账号解禁前，</span><span
      style="font-family:'等线'">默往</span><span style="font-family:'等线'">账号</span><span
      style="font-family:'等线'">中剩余的</span><span style="font-family:'等线'">默往</span><span
      style="font-family:'等线'">币</span><span style="font-family:'等线'">将被暂时冻结或全部扣除，不可继续用于兑换本平台的虚拟商品及增值服务，且本平台将根据相关法律法规对用户的账号酌情处理。对于严重违反本协议被永久封禁账号的用户，其账号中的</span><span
      style="font-family:'等线'">默往</span><span style="font-family:'等线'">币</span><span
      style="font-family:'等线'">将会被全部扣除，本平台不予返还相应的现金价值。</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">10、用户确认并同意，如用户主动注销账号，则用户在平台中充值的</span><span
      style="font-family:'等线'">默往</span><span style="font-family:'等线'">币</span><span
      style="font-family:'等线'">、使用</span><span style="font-family:'等线'">默往</span><span
      style="font-family:'等线'">币</span><span style="font-family:'等线'">兑换的虚拟商品及增值服务、会员权益等，将被视为自动放弃，本平台不予返还相应的现金价值，也不会</span><span
      style="font-family:'等线'">作出</span><span style="font-family:'等线'">任何补偿。</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">11、</span><span style="font-family:'等线'">默往</span><span
      style="font-family:'等线'">币并非</span><span style="font-family:'等线'">存款、货币、预付款或其他可在一定期限内无理由退款性质的商品或财产权利。在您充值完成后，本平台的充值服务已提供完毕，所以如无本协议约定的正当理由，本平台不提供任何</span><span
      style="font-family:'等线'">将</span><span style="font-family:'等线'">默往</span><span
      style="font-family:'等线'">币</span><span
      style="font-family:'等线'">逆向兑换为法定货币或转让给他人的服务。</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">二、服务的变更、中断、终止</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">1、鉴于网络服务的特殊性，用户同意本平台有权随时变更、中断或终止部分或全部的服务（包括平台内部的虚拟商品及增值服务）。对于本平台变更、中断或终止的服务，本平台应当尽量在变更、中断或终止之前通知用户，并应向受影响的用户提供等值的替代性的服务；如被变更、中断或终止的服务是用户通过</span><span
      style="font-family:'等线'">默往</span><span style="font-family:'等线'">币</span><span
      style="font-family:'等线'">进行兑换的，且用户不愿意接受替代性的服务，本平台将根据用户使用该服务的实际情况，将部分</span><span
      style="font-family:'等线'">默往</span><span style="font-family:'等线'">币</span><span
      style="font-family:'等线'">退还至用户。</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">2、如发生下列任何一种情形，本平台有权变更、中断或终止向用户提供服务，而无需对用户或任何第三方承担任何责任：</span>
    </p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">(1)根据法律规定用户应提交真实信息，而用户提供的个人资料不真实，或与注册时信息不一致又未能提供合理证明；</span>
    </p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">(2)用户违反相关法律法规或本协议的约定；</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">(3)按照法律规定或有权机关的要求；</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">(4)出于安全的原因或其他必要的情形。</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">三、免责声明</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">1.您知悉并同意，本平台不因下述任</span><span style="font-family:'等线'">一</span><span
      style="font-family:'等线'">情况而可能导致的任何损害赔偿承担责任，包括但不限于财产、收益、数据资料等方面的损失或其它无形损失：</span>
    </p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">（1）因不可抗力导致充值系统或服务器不稳定工作或不能正常运作（前述不可抗力包括台风、地震、海啸、洪水、停电、战争、恐怖袭击、重大卫生事件等）；</span>
    </p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">（2）因电信设施技术故障或系统维护、黑客攻击等原因造成的服务器中断、终止或延迟；</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">（3）由于各级政府、司法机关、行政机关命令及法律法规变更而导致的服务器中断、终止或延迟；</span>
    </p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">（4）由于您的主观过错导致您</span><span style="font-family:'等线'">的</span><span
      style="font-family:'等线'">默往</span><span style="font-family:'等线'">账号</span><span
      style="font-family:'等线'">密码泄露给他人（如您主动</span><span style="font-family:'等线'">将</span><span
      style="font-family:'等线'">默往</span><span style="font-family:'等线'">账号密码告知他人，有意或无意</span><span
      style="font-family:'等线'">将</span><span style="font-family:'等线'">默往</span><span
      style="font-family:'等线'">账号密码进行公开披露等）；</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">（5）您（包括未成年人用户）向本公司提供错误、不完整、不实信息等，造成您不能</span><span
      style="font-family:'等线'">使用</span><span style="font-family:'等线'">默往</span><span
      style="font-family:'等线'">账号</span><span style="font-family:'等线'">或遭受任何其他损失；</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">（6）本平台进行必要的系统升级、维护而暂停服务器或</span><span
      style="font-family:'等线'">默往</span><span style="font-family:'等线'">币充</span><span
      style="font-family:'等线'">值服务。</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">2.因您自身的主观原因导致本平台无法为您提供</span><span
      style="font-family:'等线'">默往</span><span style="font-family:'等线'">币充</span><span
      style="font-family:'等线'">值服务或本平台在提供上述服务时发生了错误而产生的任何损失，由您自行负责，</span><span
      style="font-family:'等线'">您不得</span><span style="font-family:'等线'">要求或主张本平台对您的损失</span><span
      style="font-family:'等线'">作出</span><span style="font-family:'等线'">任何补偿。前述原因包括但不限于：</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">（1）</span><span style="font-family:'等线'">您未按照</span><span
      style="font-family:'等线'">本协议或本平台不时公布的任何规则进行操作；</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">（2）您</span><span style="font-family:'等线'">的</span><span
      style="font-family:'等线'">默往</span><span style="font-family:'等线'">账号</span><span
      style="font-family:'等线'">丢失、失效、被封号等；</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">（3）因您绑定的第三方支付机构账户的原因导致的损失或责任，包括您使用未经认证的第三方支付账户或使用非您本人的第三方支付账户，您的第三方支付账户被冻结、查封等；</span>
    </p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">（4）因您个人的故意或重大过失所造成的财产损失；</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">（5）您向本平台提供了不真实的信息。</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">四、违约责任</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">如您违反本协议项下的任何规则、声明、承诺及保证，我们保留根据本公司实际损失向您追究责任的权利。</span>
    </p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">五、其他</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">1、本协议签订地为</span><span style="font-family:'等线'">厦门市湖里区</span><span
      style="font-family:'等线'">。因本协议引起的或与本协议有关的争议，本平台将与</span><span
      style="font-family:'等线'">您友好</span><span
      style="font-family:'等线'">协商解决。协商不成的，任何一方均有权向厦门市湖里区人民法院提起诉讼。</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">2、因本协议引起的或与本协议有关的争议，均适用于中华人民共和国法律。若本协议之任何规定因与中华人民共和国法律抵触或被有管辖权的人民法院认定而无效或不可执行，则在不违反法律的前提下，这些条款将按照尽可能接近本协议原条文意旨的原则重新解析，且本协议其它规定仍应具有完整的效力及效果。</span>
    </p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">3、为了向您提供更好的服务，或者基于法律规定、主管部门要求、业务开展情况等因素的更新与变化，本平台将适时对本协议内容进行修订，该等修订内容一经公布立即生效，本平台发出更新版本后，您可通过本平台</span><span
      style="font-family:'等线'">默往</span><span style="font-family:'等线'">币充</span><span
      style="font-family:'等线'">值页面随时查阅。若您在本协议内容发生修订后继续充</span><span
      style="font-family:'等线'">值</span><span style="font-family:'等线'">默往</span><span
      style="font-family:'等线'">币</span><span style="font-family:'等线'">或使用</span><span
      style="font-family:'等线'">默往</span><span style="font-family:'等线'">币</span><span
      style="font-family:'等线'">兑换虚拟商品及增值服务，则视为您同意最新修订的协议内容；否则请您立即停止充</span><span
      style="font-family:'等线'">值</span><span style="font-family:'等线'">默往</span><span
      style="font-family:'等线'">币</span><span style="font-family:'等线'">或使用</span><span
      style="font-family:'等线'">默往</span><span style="font-family:'等线'">币</span><span
      style="font-family:'等线'">兑换虚拟商品及增值服务。</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">&#xa0;</span></p>
    <p style="margin-top:0pt; margin-bottom:8pt; line-height:116%; widows:0; orphans:0; font-size:11pt"><span
      style="font-family:'等线'">4、如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有</span><span
      style="font-family:'等线'">效</span><span style="font-family:'等线'">并且有约束力。</span></p>
  </div>
</template>
<script>
export default {
  name: 'Agree2',
  created() {
    document.title = '默往币充值协议'
  }
}
</script>
<style lang="scss" scoped>
.agree {
  line-height: 1.5;
  padding: 10px;
  font-size: 15px;
}

p {
  font-size: 15px;
}
</style>
